module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/16-b810cca21e87c8e8acaf2cf82ff302b3.jpg";